<div class="filter-pill d-inline-flex align-items-center pe-0">
    <div class="filter-pill-label d-flex align-items-center border-0">
        {{ label }}
    </div>

    <div class="filter-pill-content d-flex align-items-center border-0">
        <ng-content></ng-content>

        <span *ngIf="clearable"
              role="button"
              tabindex="0"
              class="ps-2 pe-2"
              (click)="onClear()"
              (keyup.enter)="onClear()">
            <span aria-hidden="true"
                  class="filter-pill-clear d-flex bg-white justify-content-center align-items-center rounded-circle">×</span>
        </span>
    </div>
</div>
